import { pushTourStepIf } from "./tourStepHelpers.js";

/**
 * Shared workbook steps (same for every lab).
 * @returns {Array<{ element: Element, intro: string, position: string }>}
 */
export function buildWorkbookSteps() {
  const steps = [];
  const panel = document.querySelector("[data-tour='workbook-panel']");
  const story = document.querySelector("[data-tour='workbook-story']");

  pushTourStepIf(steps, panel, {
    intro:
      "This is the Workbook. It contains the lab instructions and narrative for your experiment.",
    position: "bottom"
  });

  pushTourStepIf(steps, story, {
    intro:
      "Read each passage and use the choices below to move through the lab. The Workbook guides what to do next in the Lab Area.",
    position: "top"
  });

  return steps;
}
